import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { MaskedLines } from "@/components/Reveal";
import { usePageMeta } from "@/lib/site";

export default function NotFound() {
  usePageMeta("Page Not Found", "The page you're looking for isn't on the plans.");
  return (
    <div className="relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden px-4 pt-24 text-center" data-testid="not-found-page">
      <div className="blueprint-grid absolute inset-0 opacity-30" />
      <div className="relative">
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-fog">404 — Not on the plans</p>
        <h1 className="mt-6 font-display text-5xl font-black uppercase tracking-tight sm:text-7xl">
          <MaskedLines lines={["Wrong", "Blueprints."]} />
        </h1>
        <Link to="/" data-testid="not-found-home-link" className="btn-primary mt-10">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
      </div>
    </div>
  );
}
